import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const AUTH_SPLIT_IMAGE =
  'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1600&q=80';

export function AuthSplitLayout({ children }) {
  const navigate = useNavigate();

  return (
    <div className="sba-split h-screen w-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex">
      <div className="sba-split-left flex-1 relative overflow-hidden">
        <div className="absolute top-6 left-6 z-10">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="w-10 h-10 bg-black/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-black/30 transition-all"
            aria-label="Back to home"
          >
            <ArrowLeft className="w-5 h-5 text-white" />
          </button>
        </div>
        <div className="absolute inset-0">
          <img src={AUTH_SPLIT_IMAGE} alt="Students studying" className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="sba-split-right flex-1 flex items-center justify-center bg-white">
        <div className="sba-split-panel w-full max-w-md p-8">{children}</div>
      </div>
    </div>
  );
}
